import {translations as tr} from 'compob2b-libs';

export const translations = tr;
